import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { ChevronDown } from "lucide-react";

export default function BigTile({ index, title, subtitle, count, defaultOpen = false, testid, children }) {
  const [open, setOpen] = useState(defaultOpen);
  return (
    <motion.div
      initial={{ opacity: 0, y: 24 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-40px" }}
      transition={{ duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
      className="overflow-hidden rounded-3xl border border-white/12 bg-white/[0.05]"
    >
      <button
        onClick={() => setOpen((o) => !o)}
        data-testid={testid}
        className="flex w-full items-center gap-4 p-6 text-left transition-colors hover:bg-white/[0.03]"
      >
        <span className="text-3xl font-extrabold leading-none text-[var(--accent)]">{index}</span>
        <span className="min-w-0 flex-1">
          <span className="block text-xl font-bold leading-tight text-white">{title}</span>
          {subtitle && <span className="mt-1 block text-xs text-white/50">{subtitle}</span>}
        </span>
        {count != null && (
          <span className="shrink-0 rounded-full bg-white/10 px-2.5 py-1 text-xs font-semibold text-white/70">
            {count}
          </span>
        )}
        <motion.span animate={{ rotate: open ? 180 : 0 }} transition={{ duration: 0.3 }} className="shrink-0 text-white/60">
          <ChevronDown size={22} />
        </motion.span>
      </button>
      <AnimatePresence initial={false}>
        {open && (
          <motion.div
            key="content"
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: "auto", opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            transition={{ duration: 0.35, ease: [0.22, 1, 0.36, 1] }}
          >
            <div className="px-4 pb-6 pt-1">{children}</div>
          </motion.div>
        )}
      </AnimatePresence>
    </motion.div>
  );
}
